import { ProductSearchGreeks } from 'components/secondaryMarket/productSearch/ProductSearchGreeks';
import type { DetailCellRendererProps } from 'components/shared/Blotter/DetailCellRendererFactory';
import { useAppSelector } from 'hooks/useAppSelector';
import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import type { SecondaryMarketProductInternalUser } from 'state/secondaryMarket/productSearch';
import {
  getHydratedCpGreeksForProduct,
  getHydratedLiveGreeksForProduct,
  isLoadingUnderlyingsForRowId,
} from 'state/secondaryMarket/productSearch/productSearch.selectors';
import { getUserPreferencesGreeksPrecision } from 'state/selectors';
import styled from 'styled-components';

const StyledGreeksContainer = styled.div<{ $paddingLeft: number }>`
  padding-left: ${props => props.$paddingLeft}px;
`;
export const ProductGreeksCellRenderer: FC<
  DetailCellRendererProps<SecondaryMarketProductInternalUser, { paddingLeft: number }>
> = ({ cellParams: { data }, extra: { paddingLeft } }) => {
  const closePriceGreeks = useAppSelector(state => getHydratedCpGreeksForProduct(state, data?.rowId) ?? []);
  const liveGreeks = useAppSelector(state => getHydratedLiveGreeksForProduct(state, data?.rowId) ?? []);
  const greeksPrecision = useAppSelector(state => getUserPreferencesGreeksPrecision(state)) ?? 6;
  const isLoadingGreeks = useAppSelector(state => isLoadingUnderlyingsForRowId(state, data?.rowId));
  return (
    <StyledGreeksContainer className="pe-3 py-3" $paddingLeft={paddingLeft}>
      {closePriceGreeks?.length > 0 ? (
        <>
          <h5 className="card-title py-2 text-secondary">
            <FormattedMessage id="secondaryMarket.products.greeks.closePriceGreeks" />
          </h5>
          <ProductSearchGreeks
            data={closePriceGreeks}
            greeksPrecision={greeksPrecision}
            hasSpotDate
            isLoadingGreeks={isLoadingGreeks}
          />
        </>
      ) : undefined}
      {liveGreeks?.length > 0 ? (
        <>
          <h5 className="card-title py-2 text-secondary">
            <FormattedMessage id="secondaryMarket.products.greeks.liveGreeks" />
          </h5>
          <ProductSearchGreeks data={liveGreeks} greeksPrecision={greeksPrecision} isLoadingGreeks={isLoadingGreeks} />
        </>
      ) : undefined}
    </StyledGreeksContainer>
  );
};

StyledGreeksContainer.displayName = 'StyledGreeksContainer';
